import request from '../../util/SuperagentUtils';

export const getStaticContent = (type: string, versionNumber: number) => {
  return request.get(`/api/get-static-content`).query({ typeContent: type, versionNumber: versionNumber});
};

export const getOverageInvoice = (invoiceNumber: string) => {
    return request.get(`/api/invoices-by-invoice-number/${invoiceNumber}`);
};
